import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { ErrorModalErrorDetails } from '@app/_components/error/ErrorModalErrorDetails';
import { first, HttpErrorResponse } from '@endurancewarranty/lib';
import { Button, ExpandableProvider, Flex, Text } from '@endurancewarranty/ui';
import type { TAppError, TErrorContext } from '@lib/states/error/errorAtom';
import type { FC } from 'react';
type Props = {
  className?: string;
  errorContext: TErrorContext;
  errors: TAppError[];
};
export const ErrorModalContent: FC<Props> = t0 => {
  const $ = _c(32);
  const {
    className,
    errorContext,
    errors
  } = t0;
  let t1;
  if ($[0] !== errors) {
    t1 = async () => {
      let text = "";
      errors.forEach(e => {
        const err = e.error as HttpErrorResponse;
        const metadata = err.getHttpErrorMetadata();
        text = text + `${metadata.method} ${metadata.endpoint}\n`;
        text;
        text = text + "Correlation ID:\n";
        text;
        text = text + `${metadata.correlationId}\n`;
        text;
        text = text + "Status:\n";
        text;
        text = text + `${metadata.statusCode} - ${metadata.statusMessage}\n\n`;
        text;
      });
      await navigator.clipboard.writeText(text);
    };
    $[0] = errors;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const copyTextToClipboard = t1;
  let t2;
  if ($[2] !== errorContext || $[3] !== errors) {
    t2 = () => {
      const isPaymentError = errorContext === "payment";
      if (!isPaymentError) {
        return false;
      }
      const firstPaymentError = first(errors.filter(_temp));
      const error = firstPaymentError?.error;
      return HttpErrorResponse.isHttpErrorResponse(error);
    };
    $[2] = errorContext;
    $[3] = errors;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const hasPaymentErrorMessage = t2;
  let t3;
  if ($[5] !== errorContext) {
    t3 = () => {
      switch (errorContext) {
        case "payment":
          {
            return "Our payment provider responded with the following message:";
          }
        case "unauthorized":
          {
            return "You do not have access to this feature. Please reach out to IT to request access.";
          }
        case "bad_request":
        case "default":
        default:
          {
            return "Please include the following when reaching out to IT";
          }
      }
    };
    $[5] = errorContext;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const getSubheader = t3;
  let t4;
  if ($[7] !== errorContext) {
    t4 = errorContext !== "payment" && errorContext !== "unauthorized" && <Text.Header size="xs">Troubleshooting details:</Text.Header>;
    $[7] = errorContext;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = getSubheader();
  let t6;
  if ($[9] !== t5) {
    t6 = <Text.Body color={700} size="md">{t5}</Text.Body>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <div>{t4}{t6}</div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== copyTextToClipboard || $[15] !== errorContext) {
    t8 = errorContext !== "payment" && errorContext !== "unauthorized" && <Button name="copy-error-details" variant="secondary" size="sm" onClick={copyTextToClipboard}>Copy</Button>;
    $[14] = copyTextToClipboard;
    $[15] = errorContext;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <Flex justify="between">{t7}{t8}</Flex>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== hasPaymentErrorMessage) {
    t10 = hasPaymentErrorMessage() && <Flex className="mt-1"><Text.Body color={700}>Please confirm with the customer that the <b>payment details</b> and{" "}<b>billing address</b> are correct. If the information is verified as correct and you are still seeing this message, then please ask the customer for a new payment method.</Text.Body></Flex>;
    $[20] = hasPaymentErrorMessage;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== errorContext || $[23] !== errors) {
    t11 = errorContext !== "unauthorized" && <ExpandableProvider><ErrorModalErrorDetails errors={errors} isExpandedInitial={errorContext !== "payment"} /></ExpandableProvider>;
    $[22] = errorContext;
    $[23] = errors;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t9) {
    t12 = <Flex direction="col" className="box-border h-[calc(100%-4rem)]">{t9}{t10}{t11}</Flex>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== className || $[30] !== t12) {
    t13 = <div className={className}>{t12}</div>;
    $[29] = className;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
};
function _temp(e_0) {
  return e_0.context === "payment";
}